import lfx_logo from "../../images/olfx_logo.svg";

const socialLinks = [
  {
    name: "LinkedIn",
    icon: "fa-linkedin",
    url: "https://www.linkedin.com/in/m-srishty",
  },
  {
    name: "Twitter",
    icon: "fa-twitter",
    url: "https://www.twitter.com/M_Srishty",
  },
  {
    name: "Github",
    icon: "fa-github",
    url: "https://github.com/Srish-ty",
  },
  {
    name: "Email",
    icon: "fas fa-envelope",
    url: "mailto:srushtimangutte@gmail.com",
    hide: true,
  },
  {
    name: "wp-blog",
    icon: "fa-brands fa-wordpress",
    url: "https://msrishty.wordpress.com",
  },
  {
    name: "medium-blog",
    icon: "fa-brands fa-medium",
    url: "https://medium.com/@msrishty",
  },
  {
    name: "Youtube",
    icon: "fa-youtube",
    url: "https://www.youtube.com/@l4dybu9",
  },
  {
    name: "lfx",
    icon: "fas fa-laptop",
    img: lfx_logo,
    url: "https://openprofile.dev/profile/l4dybu6",
  },
];

export default socialLinks;
